import React from 'react';

import { useCapturedCoordinates } from 'components/BackgroundReplacer/SourceTemplate/SimpleEditor/useCapturedCoordinates';

import { Point } from './types';

type ReturnType = [
  handlePointerDown: (event: React.PointerEvent) => void,
  handlePointerMove: (event: React.PointerEvent) => void,
  handlePointerUp: (event: React.PointerEvent) => void,
];

interface Props {
  center: Point;
  setTransform: (point: Point) => Point;
  moveTransform: (point: Point) => Point;
  getAreaStartPoint: () => Point;
  onMove: (point: Point | null, eventPoint: Point) => void;
}

export const usePointerEvents = ({
  center,
  setTransform,
  moveTransform,
  getAreaStartPoint,
  onMove,
}: Props): ReturnType => {
  const [
    setCapturedCoordinates,
    withCapturedCoordinates,
    releaseCapturedCoordinates,
  ] = useCapturedCoordinates(getAreaStartPoint);

  const handlePointerDown = (event: React.PointerEvent): void => {
    event.preventDefault();

    setCapturedCoordinates(event, center, setTransform);

    const target = event.target as HTMLElement;
    target.setPointerCapture(event.pointerId);
  };

  const handlePointerMove = (event: React.PointerEvent): void => {
    event.preventDefault();

    const point = withCapturedCoordinates(event, moveTransform);
    onMove(point, { x: event.clientX, y: event.clientY });
  };

  const handlePointerUp = (event: React.PointerEvent): void => {
    const target = event.target as HTMLElement;
    target.releasePointerCapture(event.pointerId);

    releaseCapturedCoordinates();
  };

  return [handlePointerDown, handlePointerMove, handlePointerUp];
};
